module.exports = __webpack_public_path__ + "media/images/links/ips-a8f2e91f845d21ba82fe177daa49944e.jpg";